import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import { Button, Checkbox, Chip, CircularProgress, FormControl, Grid, InputLabel, List, ListItem, ListItemText, MenuItem, OutlinedInput, Paper, Select, SelectChangeEvent, StepLabel, TextField, Typography } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import $ from "jquery";
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import AutoAwesomeMosaicOutlinedIcon from '@mui/icons-material/AutoAwesomeMosaicOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Common from '../utilities/common';
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';
import { FieldMap } from '../models/FieldMap';
import { NormalizeItem } from '../models/NormalizeItem';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { DataGrid, GridRowSelectionModel } from '@mui/x-data-grid';

export interface IStepsState {
    activeStep: number;
    fileName: string;
    actions: string[];
    response: any[];
    customSeparator: boolean;
    csvSeparator: string;
    hasColumnNames: boolean;
    fieldMap: any;
    columns: any[];
}

export default class NormalizeData extends React.Component<{}, IStepsState> {
    _file: any;
    _firstRowHasColumnNames: boolean = false;

    public constructor(props: {}) {
        super(props);

        this.state = {
            activeStep: 0,
            fileName: '',
            actions: [],
            response: [],
            customSeparator: false,
            csvSeparator: '',
            hasColumnNames: false,
            fieldMap: {},
            columns: []
        }
    }

    public render(): React.ReactElement<{}> {
        return (
            <Box sx={{ flexGrow: 1 }}>
                <Box sx={{ marginTop: '20px' }} className='stepper'>
                    <Stepper activeStep={this.state.activeStep}>
                        <Step key="selectFile" completed={this.state.fileName != ''}>
                            <StepLabel>Archivo</StepLabel>
                        </Step>
                        <Step key="selectActions" completed={this.state.actions.length > 0}>
                            <StepLabel>Acción</StepLabel>
                        </Step>
                        <Step key="result" completed={this.state.activeStep > 2}>
                            <StepLabel>Campos</StepLabel>
                        </Step>
                        <Step key="resume">
                            <StepLabel>Resumen</StepLabel>
                        </Step>
                    </Stepper>
                </Box>
                {
                    //ARCHIVO
                    this.state.activeStep == 0 && (
                        <Box className='main'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <CloudUploadOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={11}>
                                    <Typography className='mainTitle'>
                                        {this.state.fileName == '' ? 'Seleccione el archivo de datos a normalizar' : this.state.fileName}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Box sx={{ padding: '40px 0px', textAlign: 'center'}}>
                                <Button variant="contained" onClick={this.SelectFile.bind(this)}>Seleccionar archivo</Button>
                                <input type='file' id='txtFile' className='hidden' accept=".csv, .txt, .xls, .xlsx" onChange={this.ShowFileName.bind(this)}/>
                            </Box>
                            {
                                this.state.fileName != '' && (this.state.fileName.endsWith('.csv') || this.state.fileName.endsWith('.txt')) && (
                                    <Box sx={{ width: '500px', margin: '0 auto', marginTop: '40px'}}>
                                        <FormControl fullWidth>
                                            <InputLabel id="labelSeparator">Indique el separador de columnas</InputLabel>
                                            <Select label="Indique el separador de columnas" labelId='labelSeparator' onChange={(event: SelectChangeEvent) => {
                                                this.setState({
                                                    customSeparator: (event.target.value as string) == 'otro',
                                                    csvSeparator: event.target.value as string
                                                });
                                            }}>
                                                <MenuItem value={','}>Coma (,)</MenuItem>
                                                <MenuItem value={';'}>Punto y coma (;)</MenuItem>
                                                <MenuItem value={'|'}>Pipe (|)</MenuItem>
                                                <MenuItem value={'#'}>Almohadilla (#)</MenuItem>
                                                <MenuItem value={'\t'}>Tabulado</MenuItem>
                                                <MenuItem value={' '}>Espacio en blanco</MenuItem>
                                                <MenuItem value={'otro'}>Otro</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {
                                            this.state.customSeparator && (
                                                <FormControl fullWidth style={{marginTop: '20px'}}>
                                                    <TextField label="Introduzca el separador de columnas" variant="outlined" onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                        this.setState({
                                                            csvSeparator: event.target.value
                                                        });
                                                    }}/>
                                                </FormControl>
                                            )
                                        }
                                    </Box>
                                )
                            }
                            <Box sx={{marginTop: '40px'}}>
                                {
                                    this.state.fileName != '' && this.state.response.length == 0 && (
                                        <div style={{textAlign: 'center'}}>
                                            <CircularProgress />
                                            <Typography variant='body1'>Obteniendo información del archivo</Typography>
                                        </div>
                                    )
                                }
                                {
                                    this.state.response.length > 0 && (
                                        <div>
                                            <Grid container style={{borderBottom: 'solid 1px #666', marginBottom: '40px'}}>
                                                <Grid item xs={4}>
                                                    <Typography variant='h6'>Contenido del archivo</Typography>
                                                </Grid>
                                                <Grid item xs={8} style={{textAlign: 'right'}}>
                                                    <FormControlLabel control={<Switch defaultChecked={false} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                        if(event.target.checked) {
                                                            this._firstRowHasColumnNames = true;
                                                        }
                                                        else {
                                                            this._firstRowHasColumnNames = false;
                                                        }

                                                        this.UploadFile();
                                                    }}/>} label="La primera fila contiene los nombres de las columnas" />
                                                </Grid>
                                            </Grid>
                                            <DataGrid
                                                rows={this.state.response}
                                                hideFooter={this.state.response.length <= 30}
                                                columns={this.state.columns}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: { page: 0, pageSize: 30 },
                                                    },
                                                }}
                                                pageSizeOptions={[30, 60, 100]}
                                                checkboxSelection={false}
                                                slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                            />
                                        </div>
                                    )
                                }
                            </Box>
                        </Box>
                    )
                }
                {
                    //ACCIÓN
                    this.state.activeStep == 1 && (
                        <Box className='main'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <AutoAwesomeMosaicOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={11}>
                                    <Typography className='mainTitle'>
                                    Seleccione los elementos que desea normalizar
                                    </Typography>
                                </Grid>
                            </Grid>
                            <FormGroup style={{width: '350px', margin: '0 auto'}}>
                                <FormControlLabel control={<Switch defaultChecked={false} checked={this.state.actions.indexOf('Nombres') > -1} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.checked){
                                        this.AddAction('Nombres');
                                    }
                                    else {
                                        this.RemoveAction('Nombres');
                                    }
                                }}/>} label="Nombres y apellidos" />
                                <FormControlLabel control={<Switch defaultChecked={false} checked={this.state.actions.indexOf('Direcciones') > -1} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.checked){
                                        this.AddAction('Direcciones');
                                    }
                                    else {
                                        this.RemoveAction('Direcciones');
                                    }
                                }}/>} label="Direcciones" />
                                <FormControlLabel control={<Switch defaultChecked={false} checked={this.state.actions.indexOf('CP') > -1} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.checked){
                                        this.AddAction('CP');
                                    }
                                    else {
                                        this.RemoveAction('CP');
                                    }
                                }}/>} label="CP" />
                                <FormControlLabel control={<Switch defaultChecked={false} checked={this.state.actions.indexOf('Sexo') > -1} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.checked){
                                        this.AddAction('Sexo');
                                    }
                                    else {
                                        this.RemoveAction('Sexo');
                                    }
                                }}/>} label="Sexo" />
                            </FormGroup>
                        </Box>
                    )
                }
                {
                    //RELACIÓN DE CAMPOS
                    this.state.activeStep == 2 && (
                        <Box className='main'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <SignpostOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={11}>
                                    <Typography className='mainTitle'>
                                    Indique la relación entre los campos del archivo
                                    </Typography>
                                </Grid>
                            </Grid>
                            {
                                Common.DATA_FIELDS.map((field: string, index: number) => {
                                    return (
                                        <Grid container spacing={2} style={{width: '600px', margin: '0 auto'}}>
                                            <Grid item xs={4} style={{textAlign: 'left'}}>
                                                <Typography style={{marginTop: '10px'}} fontWeight={600}>
                                                    {
                                                        Common.DATA_DISPLAY_FIELDS[index]
                                                    }
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={8} style={{padding: '10px 0px'}}>
                                                <FormControl fullWidth>
                                                    <InputLabel id={`label${index}`}>Campo del archivo</InputLabel>
                                                    <Select 
                                                        key={`select${index}`}
                                                        label="Campo del archivo" 
                                                        multiple
                                                        value={this.state.fieldMap[field] != null ? this.state.fieldMap[field]!.split(',') : []}
                                                        labelId={`label${index}`} 
                                                        style={{textAlign: 'left'}} 
                                                        renderValue={(selected) => (
                                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                {
                                                                    selected.map((value) => (
                                                                        <Chip key={value} label={value} />
                                                                    ))
                                                                }
                                                            </Box>
                                                        )}
                                                        onChange={(event: SelectChangeEvent<string[]>) => {
                                                            let fieldMap: FieldMap = this.state.fieldMap;

                                                            const values: string[] = [];
                                                            
                                                            for(let i = 0; i < event.target.value.length; i++) {
                                                                values.push(event.target.value[i]);
                                                            }

                                                            if(values.length > 0) {
                                                                fieldMap[field] = values.join(',');
                                                            }
                                                            else {
                                                                fieldMap[field] = undefined;
                                                            }

                                                            this.setState({
                                                                fieldMap: fieldMap
                                                            });
                                                        }}
                                                    >
                                                        {
                                                            Object.getOwnPropertyNames(this.state.response[0]).map((prop: string, propIndex: number) => {
                                                                return (
                                                                    <MenuItem value={prop} key={propIndex}>
                                                                        <Checkbox checked={this.state.fieldMap[field] == null ? false : this.state.fieldMap[field]!.split(',').indexOf(prop) > -1}/>
                                                                        <ListItemText primary={prop} />
                                                                    </MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    )
                                })
                            }
                        </Box>
                    )
                }
                {
                    //RESUMEN
                    this.state.activeStep == 3 && (
                        <Box className='main'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <SettingsOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={11}>
                                    <Typography className='mainTitle'>
                                    Configuración
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} style={{marginTop: '20px'}}>
                                <Grid item xs={2}>
                                    <strong>Archivo a normalizar:</strong>
                                </Grid>
                                <Grid item xs={10}>
                                    {
                                        this.state.fileName
                                    }
                                </Grid>
                                <Grid item xs={2}>
                                    <strong>Normalizar:</strong>
                                </Grid>
                                <Grid item xs={10}>
                                    <List style={{paddingTop: '0px', paddingBottom: '0px'}}>
                                        {
                                            this.state.actions.map((value: string, index: number) => {
                                                return (
                                                    <ListItem disablePadding key={`action-${index}`}>
                                                        {
                                                            value
                                                        }
                                                    </ListItem>
                                                )
                                            })
                                        }
                                    </List>
                                </Grid>
                                <Grid item xs={2}>
                                    <strong>Relación de campos:</strong>
                                </Grid>
                                <Grid item xs={10}>
                                    <List style={{paddingTop: '0px', paddingBottom: '0px'}}>
                                        {
                                            Object.getOwnPropertyNames(this.state.fieldMap).map((prop: string, propIndex: number) => {
                                                return (
                                                    <ListItem disablePadding value={prop} key={propIndex}>
                                                        {
                                                            `${prop}: ${this.state.fieldMap[prop]}`
                                                        }
                                                    </ListItem>
                                                )
                                            })
                                        }
                                    </List>
                                </Grid>
                            </Grid>
                        </Box>
                    )
                }
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} className='stepper'>
                    <Button variant="text" onClick={this.PrevStep.bind(this)} disabled={this.state.activeStep == 0}>Anterior</Button>
                    <Button variant="text" onClick={this.NextStep.bind(this)} disabled={this.DisableNextButton()}>
                        {this.state.activeStep == 3 ? 'Iniciar normalización' : 'Siguiente'}
                    </Button>
                </Box>
            </Box>
        )
    }

    private PrevStep(): void {
        let activeStep = this.state.activeStep;
        activeStep--;

        this.setState(
            {
                activeStep: activeStep
            }
        )
    }

    private NextStep(): void {
        let activeStep = this.state.activeStep;
        activeStep++;

        if (activeStep > 3) {
            this.SaveFile();
        }
        else {
            this.setState(
                {
                    activeStep: activeStep
                }
            )
        }
    }

    private SelectFile(): void {
        $('#txtFile').click();
    }

    private ShowFileName(): void {
        if($('#txtFile').val() != null) {
            const file = document.getElementById('txtFile') as HTMLInputElement;
            this._file = file!.files![0];
            const selectedFileName = ($('#txtFile').val() as string).split('\\').pop();
            this.setState(
                {
                    fileName: selectedFileName!
                }
            )

            this.UploadFile();
        }
    }

    private AddAction(action: string): void {
        const actions: string[] = this.state.actions;
        actions.push(action);

        this.setState(
            {
                actions: actions
            }
        )
    }

    private RemoveAction(action: string): void {
        const actions: string[] = this.state.actions;
        actions.splice(actions.indexOf(action), 1); 

        this.setState(
            {
                actions: actions
            }
        )
    }


    private DisableNextButton(): boolean {
        if (this.state.activeStep == 0) {
            if (this.state.fileName.endsWith('.csv')) {
                return this.state.csvSeparator == '' || this.state.csvSeparator == 'otro'
            }

            return this.state.response.length == 0;
        }

        if (this.state.activeStep == 1) {
            return this.state.actions.length == 0;
        }

        if (this.state.activeStep == 2) {
            let isNotInitialize: boolean = true;

            for (let key in this.state.fieldMap) {
                if (this.state.fieldMap[key] != undefined && this.state.fieldMap[key]!.length > 0) {
                    isNotInitialize = false;
                    break;
                }
            }

            return isNotInitialize;
        }

        return false;
    }

    private UploadFile(): void {
        let url = `${Common.END_POINT}/excel/upload`;

        if (this._firstRowHasColumnNames) {
            url = `${Common.END_POINT}/excel/upload/withcolumnnames`;
        }

        const data = new FormData();
        data.append('file', this._file);
        $.ajax((
            {
                url: url,
                type: "POST",
                data: data,
                processData: false,
                contentType: false,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const columns: any[] = [];
            const firstRow = response[0];

            for(let key in firstRow) {
                if(key != 'id') {
                    columns.push(
                        { 
                            field: key, 
                            headerName: key, 
                            width: 200 
                        }
                    )
                }
            }

            this.setState({
                response: response,
                columns: columns
            });
        })
    }

    private SaveFile(): void {
        let url = `${Common.END_POINT}/upload`;
        const data = new FormData();
        data.append('file', this._file);
        $.ajax((
            {
                url: url,
                type: "POST",
                data: data,
                processData: false,
                contentType: false,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            this.SetNormalization(response);
        })
    }

    private SetNormalization(id: number): void {
        let url = `${Common.END_POINT}/normalize/set`;
        let normalizeItem: NormalizeItem = new NormalizeItem();
        normalizeItem.ID = id;
        normalizeItem.Actions = this.state.actions.join(",");
        normalizeItem.FieldMap = JSON.stringify(this.state.fieldMap);

        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(normalizeItem),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            window.location.href = "/normalizaciones";
        }).fail((jqXHR, textStatus, errorThrown) => {
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
        })
    }
}